import { themeConfig } from '@gap/shared/theme'
import GapChip from 'features/gap-components/status-chip/GapChip'

/** Marks a client, meeting, or org as seeded demo data. */
export default function DemoChip() {
   return (
      <GapChip
         colorVariant="demo"
         label="Demo"
         sx={{ fontSize: themeConfig.typographyProps.caption.fontSize, height: '20px', paddingY: '0px' }}
      />
   )
}
